<gen-dynamic-form
    *ngIf="formConfig"
    [popupMode]="true"
    [formConfig]="formConfig"
    [editMode]="true"
    [formData]=""
    [formVertical]="true"
    [disabled]="false"
    [requiredMessage]="''"
    [mapAllProperties]="true"
    (formChange)="updateEventTypeSelection($event)"
></gen-dynamic-form>
